import { useQuery } from "@tanstack/react-query";
import { getTaskImages } from "@coworker/apprestructured/src/task-management/services/tasks.service";
import { getTaskImagesQueryKey } from "@coworker/apprestructured/src/task-management/services/queryKeyHelper";
import { createPreviousOnNullPlaceholderDataFn } from "@coworker/apprestructured/src/task-management/services/queryHelper";
import { SignedUpload } from "@coworker/apprestructured/src/task-management/types/Upload";
import { signedUploadsToExistingFiles } from "@coworker/apprestructured/src/uploader/uploader.helper";
import { useCallback } from "react";
import { sortByIdOrder } from "@coworker/apprestructured/src/shared/helpers/object.helper";

export function useTaskImages(
  taskId: string | null,
  order?: string[] | undefined
) {
  const select = useCallback(
    (uploads: SignedUpload[]) => {
      return signedUploadsToExistingFiles(sortByIdOrder(uploads, order));
    },
    [order]
  );

  return useQuery({
    queryKey: getTaskImagesQueryKey(taskId),
    queryFn: () => getTaskImages(taskId!),
    enabled: taskId !== null,
    placeholderData:
      createPreviousOnNullPlaceholderDataFn<SignedUpload[]>(taskId),
    // This is highly opinionated because it is what we currently use.
    // If you need the actual uploads, feel free to set this as a param instead.
    select,
  });
}
